export default {"src":"/_next/static/media/logo-visa.7a633545.svg","height":32,"width":55,"blurWidth":0,"blurHeight":0};